import type { FaireProductEntity } from "../../entity_types/product";

export const p_4vxshfbxa9: FaireProductEntity = {
  token: "p_4vxshfbxa9",
  type: "product",
  name: "Habtamu Fikadu, Ethiopia",
  brandToken: "b_3juit7iu0l",
  brandName: "Go Get Em Tiger",
  imageUrl: "https://cdn.faire.com/fastly/420377e0bbcb8986e8ac6fe8994c9309f5cec338260c2936bcb5336f6b79e957.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/795d7969e11d6bba30ad42e708f287932e954f06d908ae1b9168bdcc831d632c.jpeg",
    "https://cdn.faire.com/fastly/3120cf57be429b958f220e2e80a0cb638c864f77e6e1ca41baa39fe92913f0bb.jpeg"
  ],
  priceDollars: 14.81,
  description: "Produced at the Goro Site washing station, this coffee reflects Habtamu Fekadu Aga’s focus on careful processing and long-term farm quality. After harvest, the coffee is fermented for 24 hours with 10% of the mucilage intact, then hand-washed and dried on raised beds for 8–12 days. Drying takes place out of direct sunlight to prevent scorching and encourage a slow, even finish. The station also supports farmers with agronomy education centered on organic methods, shade growing, and regenerative practices that help improve both coffee quality and environmental health.\n\n",
  tags: [],
  msrpDollars: 29.62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:35.550Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
